import { ComponentPublicInstance, computed, ref } from "vue";
import store from "@/state/store";

const contentType = ref("");
export const personalizationOnboardingHeader = computed(() => {
  if (contentType.value === "playbook_email") {
    return "The Playbook emails contain links to personally branded content. Add your photo and other key info and we'll take care of the rest!";
  } else if (contentType.value === "blog") {
    return "The blog posts are hosted on your own personalized page. Add your photo and other key info and we'll take care of the rest!";
  } else if (contentType.value === "video") {
    return "The videos are hosted on your own personalized page. Add your photo and other key info and we'll take care of the rest!";
  }
  return "";
});

const loadedProfile = computed(() =>
  store.getters["profile/getProfileByFeature"]("basic")
);

const hasLogo = computed(() => {
  return loadedProfile.value.logo?.value !== "";
});

const hasPhoto = computed(() => {
  return loadedProfile.value.photo?.value !== "";
});

const needsPersonalization = (contentType: string) => {
  return (
    !hasLogo.value &&
    !hasPhoto.value &&
    ["blog", "video", "playbook_email"].includes(contentType)
  );
};

export const checkProfileShouldContinue = async (
  type: string,
  proxy: ComponentPublicInstance
): Promise<boolean> => {
  if (needsPersonalization(type)) {
    contentType.value = type;
    const didSave = await openProfileModal(proxy);
    if (!didSave) return false;
  }
  return true;
};

const openProfileModal = (proxy: ComponentPublicInstance): Promise<boolean> => {
  return new Promise((resolve) => {
    const modalId = "onboarding-profile-modal";
    let didSave = false;

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    proxy!.$root.$once("save", () => {
      didSave = true;
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onHidden = (_bvEvent: any, closedModalId: string): void => {
      if (closedModalId === modalId) {
        proxy?.$root.$off("bv::modal::hidden", onHidden); // Clean up
        resolve(didSave);
      }
    };

    proxy?.$root.$on("bv::modal::hidden", onHidden);
    proxy?.$bvModal.show(modalId);
  });
};
